// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"2312eefc","147":"48198676","295":"27a5dd66","574":"d0221ff1","807":"d51a26f1","818":"fb9740f8","899":"8da7f6cb","900":"815301c4","996":"126a7c0d"}[chunkId] + ".chunk.js";
};